<template>
  <Loading :loading="loading">
    <div v-if="error">
      {{error}}
    </div>
    <div v-else>
      <div class="container">
        <div class="row">
          <div class="col-12 backButton">
            <router-link
              class="btn btn-outline-primary"
              :to="{path: $route.query.backRoute}"
            >Back To {{$route.query.backName}}</router-link>
          </div>
          <h1 class="productTitle">{{$route.query.title}}</h1>
        </div>
      </div>
      <WordpressDisplayContent
        :pageData="this.pageData"
      />
    </div>
  </Loading>
</template>

<script>

import { fetchSingleBlogPost } from "@/network/wordpressRequests"
import Loading from "@/components/loading/Loading";
import WordpressDisplayContent from "../WordpressDisplayContent"

export default {
  name: 'Post',
  components: {
    Loading,
    WordpressDisplayContent
  },
  data(){
    return {
      pageData: null,
      loading: true,
      error: null
    }
  },
  created(){
    this.loadData()
  },
  methods:{
    loadData(){
      this.error=""
      this.loading=true
      let id = this.$route.params.postId
      fetchSingleBlogPost(id,result => {
        this.pageData = result[0]
        this.loading=false
      },
      (error) => { //on error
        this.error = "Error loading content";
        console.log(error)
        //reload
        setTimeout(() => {this.loadData()}, 2000)
      })
    }
  },
  computed:{
    pageContent(){
      return this.pageData[0];
    }
  },
  watch: {
    loading() {
      //if loading event happens, emeit loaded event
      //allows container components to show loading icon for wordpress content
      this.$emit("loaded");
    },
    //update data whenever a parameter changes
    pageSlug() {
      this.loadData();
    }
  }
}
</script>

<style lang="scss" scoped>
  .backButton{
    padding: 20px 0;
  }

  @include media-breakpoint-up(md){
    .backButton, .productTitle{
      padding-left: 15px;
    }
  }
  h1{
    color: #AF272F;
  }
  h3{
    font-weight: bold;
    color: #000;
  }
</style>
